import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TrustpilotStarsService {
  regExp = /\[trustpilotStars(?:\s+cssClasses="([^"]*)")?\]/g;

  /**
   * trustpilotStarsParser replaces [trustpilotStars] shortcodes with HTML placeholders
   * that will be dynamically replaced with the actual Angular component
   * Supports optional cssClasses attribute: [trustpilotStars cssClasses="my-4 text-center"]
   *
   * @param {string} content - HTML content containing [trustpilotStars] shortcodes
   * @return {string} - HTML content with placeholders instead of shortcodes
   */
  trustpilotStarsParser = (content: string): string => {
    if (content && typeof content === 'string') {
      const trustpilotStarsInstances = [...content.matchAll(this.regExp)];

      // No trustpilotStars shortcode found, return unmodified content
      if (!trustpilotStarsInstances.length) {
        return content;
      }

      // Replace each [trustpilotStars] shortcode with a placeholder div
      trustpilotStarsInstances.forEach((instance, index) => {
        const cssClasses = instance[1] || ''; // Extract cssClasses if provided
        const uniqueId = `trustpilot-stars-${Date.now()}-${index}`;
        const cssClassesAttribute = cssClasses ? ` data-css-classes="${cssClasses}"` : '';
        const trustpilotStarsHtml = `<div id="${uniqueId}" class="trustpilot-stars-placeholder" data-component="trustpilotStars"${cssClassesAttribute}></div>`;

        // Replace the shortcode with the placeholder HTML
        content = content.replace(instance[0], trustpilotStarsHtml);
      });
    }

    return content;
  };
}
